import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.css']
})
export class ContactModalComponent implements OnInit {
  contact: any;
  birthday: string;
  startdate: string;
  manager: string;

  constructor(private dialogRef: MatDialogRef<ContactModalComponent>, 
    @Inject(MAT_DIALOG_DATA) data: { employee: any},
    @Inject(DOCUMENT) private document: Document) {
      this.dialogRef = dialogRef;
    }

  ngOnInit(): void { 
    console.log("2",window.scrollY)
    window.scrollTo(0, 150)
    console.log("2",window.scrollY)
  }

  close(event?) {
    if (event) {
      this.dialogRef.close({type: event});
    } else {
      this.dialogRef.close();
    }
  }

}
